import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { usePrefixCls } from '../_utils';
import { ThumbnailProps } from './interface';

const IMAGE_FILE_TYPES = ['jpg', 'jpeg', 'png', 'bmp'];

function isImageFileType(fileType?: string): boolean {
  if (!fileType) return true;
  return IMAGE_FILE_TYPES.includes(fileType.toLowerCase());
}

const Thumbnail: React.FC<ThumbnailProps> = props => {
  const { active, imageUrl, fileType, previewImg, className, style, onChoose = () => {} } = props;
  const [isError, setIsError] = useState(false);
  const prefixCls = usePrefixCls('thumbnail');

  useEffect(() => {
    setIsError(false);
  }, [imageUrl, previewImg]);

  const classes = classnames(
    prefixCls,
    { 'is-active': !!active },
    className
  );

  const handleError = () => {
    setIsError(true);
  };

  const handleLoad = () => {
    setIsError(false);
  };

  const errorIcon = (
    <svg width="80" height="80" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.01" x="24" y="24" width="72" height="72" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M30 84V36H90V84H30Z" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M39 55.5H81V58.5H39V55.5Z" fill="#C1CCDD" />
      <path fillRule="evenodd" clipRule="evenodd" d="M39 66H69V69H39V66Z" fill="#C1CCDD" />
      <rect x="30" y="36" width="60" height="10.5" fill="#C1CCDD" />
      <rect opacity="0.01" x="72" y="66" width="30" height="30" fill="white" />
      <circle cx="87" cy="81" r="10.5" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M87 69C80.373 69 75 74.373 75 81C75 87.627 80.373 93 87 93C93.627 93 99 87.627 99 81C99 74.373 93.627 69 87 69ZM88.5 87V84H85.5V87H88.5ZM88.5 75V82.5H85.5V75H88.5Z" fill="#006EFF" />
    </svg>
  );

  // 非图片类型（pdf/doc/xls/ppt/txt/md 等）且未配置首图时，
  // 渲染一个友好的文档占位卡片，而不是报错图标
  const fileIcon = (
    <svg width="48" height="60" viewBox="0 0 48 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 3C6 1.34315 7.34315 0 9 0H30L42 12V57C42 58.6569 40.6569 60 39 60H9C7.34315 60 6 58.6569 6 57V3Z"
        fill="#fff"
      />
      <path d="M30 0L42 12H33C31.3431 12 30 10.6569 30 9V0Z" fill="#DCE3F0" />
      <rect x="14" y="24" width="20" height="3" rx="1.5" fill="#C1CCDD" />
      <rect x="14" y="32" width="20" height="3" rx="1.5" fill="#C1CCDD" />
      <rect x="14" y="40" width="12" height="3" rx="1.5" fill="#C1CCDD" />
    </svg>
  );

  const fileCard = (
    <div className={`${prefixCls}-file`}>
      <div className={`${prefixCls}-file__icon`}>{fileIcon}</div>
    </div>
  );

  const isImage = isImageFileType(fileType);
  // 优先使用配置的首图预览；否则图片类型才用 imageUrl 渲染
  const displaySrc = previewImg || (isImage ? imageUrl : '');

  const renderContent = () => {
    if (!displaySrc) return fileCard;

    if (isError) {
      // 加载失败：图片类型显示错误图标，非图片类型回退到文档卡片
      return isImage ? (
        <div className={`${prefixCls}-error`}>
          <div className={`${prefixCls}-error__img`}>{errorIcon}</div>
        </div>
      ) : (
        fileCard
      );
    }

    return (
      <div className={`${prefixCls}__object`}>
        <img
          onLoad={handleLoad}
          className={`${prefixCls}__image`}
          src={displaySrc}
          onError={handleError}
          alt=""
        />
      </div>
    );
  };

  return (
    <div className={classes} style={style} onClick={() => onChoose()}>
      {renderContent()}
    </div>
  );
};

export default Thumbnail;
